import moment from 'moment';
import kennitala from 'kennitala';

import parse from '../parse';
import strip from '../strip';

const required = (value) => (value ? undefined : 'Error.Input.Required');

const onlyNumbers = (value) => (isNaN(parse.decimal(value)) ? 'Error.NumbersOnly' : undefined);

const maxLength = (max) => (formValue) => (formValue && formValue.length > max ? 'Error.ExceedsMaxLength' : undefined);

const maxLength35 = maxLength(35);
const maxLength20 = maxLength(20);

const phoneNumber = (value) => {
  if (value === undefined || value === '') {
    return 'Error.EmptyField';
  }
  if (value.length !== 7) {
    return 'Error.InvalidPhoneNumber';
  }
  if (!['6', '7', '8'].includes(phoneNumber[0])) {
    return { phoneNumber: 'Error.InvalidPhoneNumber' };
  }
  return undefined;
};

const creditCard = (cardNumber) => {
  // accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(cardNumber)) return false;

  // The Luhn Algorithm. It's so pretty.
  let nCheck = 0;
  let nDigit = 0;
  let bEven = false;
  let value = cardNumber;
  value = value.replace(/\D/g, '');

  for (let n = value.length - 1; n >= 0; n--) {
    const cDigit = value.charAt(n);
    nDigit = parseInt(cDigit, 10);

    if (bEven) {
      if ((nDigit *= 2) > 9) {
        nDigit -= 9;
      }
    }
    nCheck += nDigit;
    bEven = !bEven;
  }
  return nCheck % 10 === 0;
};

const ssn = (value) => {
  // Það verður að athuga lengd á kennitölu fyrst af því að validate.ssn() skilar stundum true þó það sé length === 9
  const strippedKT = kennitala.clean(value);

  if (strippedKT.length === 10) {
    return kennitala.isValid(value);
  }
  return false;
};

const minPasswordLength = 4;

const validate = {
  required,
  onlyNumbers,
  maxLength35,
  maxLength20,
  phoneNumber,
  creditCard,
  minPasswordLength,
  ssn,
};

export default validate;
